// translations/pages/team/es.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageES = {
  hero: {
    title: 'Equipo',
    intro: 'Adrian Eisenmeier y Nikolai Genov fundaron pAIoneer Labs GmbH y la dirigen como directores generales.',
    members: 'Adrian Eisenmeier es físico diplomado y desarrolla sistemas allí donde confluyen la IA, la arquitectura de software, la protección de datos y la seguridad. Nikolai Genov es doctor en bioinformática y responsable técnico del desarrollo de software asistido por IA y de la analítica en entornos regulados de salud, ciencias de la vida y finanzas. Alina Tselinina es desarrolladora de software e ingeniera de datos con un máster en matemáticas financieras y actuariales y desarrolla aplicaciones, API REST y pipelines de datos en Python y R.'
  },
  card: {
    cta: 'Ver perfil'
  },
  profile: {
    overview: 'Equipo',
    membersLabel: 'Miembros del equipo'
  }
};
